import { PreviousOwnerUsageHistoryOptions, previousOwnerUsageHistoryOptionsMessages } from "@slfinrtl/ui-bff-routes"
import { useIntl } from "react-intl"
import type { Option } from "src/components/form/select/Select"

export const usePreviousOwnerUsageHistoryOptions = (): Option<PreviousOwnerUsageHistoryOptions>[] => {
	const { formatMessage } = useIntl()
	return [
		{
			label: formatMessage(previousOwnerUsageHistoryOptionsMessages.PRIVATE),
			value: PreviousOwnerUsageHistoryOptions.PRIVATE,
		},
		{
			label: formatMessage(previousOwnerUsageHistoryOptionsMessages.BUSINESS),
			value: PreviousOwnerUsageHistoryOptions.BUSINESS,
		},
		{
			label: formatMessage(previousOwnerUsageHistoryOptionsMessages.RENTAL),
			value: PreviousOwnerUsageHistoryOptions.RENTAL,
		},
		{
			label: formatMessage(previousOwnerUsageHistoryOptionsMessages.OTHER),
			value: PreviousOwnerUsageHistoryOptions.OTHER,
		},
	]
}
